import {
  AsanaLogo,
  AzureBoardsLogo,
  GitHub,
  JiraSoftwareLogo,
  JiraSoftwareLogoOutlined
} from "@/icons"

import type { TicketingSystem } from "@/domain/ticketing"
import type { IconProps } from "@/icons"

export const TICKETING_LOGOS: Record<TicketingSystem, React.FC<IconProps>> = {
  jira: JiraSoftwareLogo,
  azure_boards: AzureBoardsLogo,
  asana: AsanaLogo,
  github: GitHub
}

export const TICKETING_OUTLINED_LOGOS: Record<
  TicketingSystem,
  React.FC<IconProps>
> = { ...TICKETING_LOGOS, jira: JiraSoftwareLogoOutlined }
